import { render, staticRenderFns } from "./LobbyCreation.vue?vue&type=template&id=51b7e792"
import script from "./LobbyCreation.vue?vue&type=script&lang=js"
export * from "./LobbyCreation.vue?vue&type=script&lang=js"
import style0 from "./LobbyCreation.vue?vue&type=style&index=0&id=51b7e792&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports